module.exports = __webpack_public_path__ + "static/media/record.ae0001b7.svg";